export const SEA_DISTRICTS = [
  {
    id: 41,
    name: 'Bottenviken',
    latlon: [64.926335, 22.958937],
  },
  {
    id: 42,
    name: 'Norra Kvarken',
    latlon: [63.443633, 20.806637],
  },
  {
    id: 43,
    name: 'Norra Bottenhavet',
    latlon: [62.51536, 19.708525],
  },
  {
    id: 44,
    name: 'Södra Bottenhavet',
    latlon: [61.441919, 19.181431],
  },
  {
    id: 45,
    name: 'Ålands hav',
    latlon: [60.166655, 19.335167],
  },
  {
    id: 46,
    name: 'Skärgårdshavet',
    latlon: [60.243083, 20.982335],
  },
  {
    id: 62,
    name: 'Mälaren',
    latlon: [59.401973, 17.403722],
  },
  {
    id: 47,
    name: 'Finska viken',
    latlon: [59.770779, 25.022534],
  },
  {
    id: 50,
    name: 'Rigabukten',
    latlon: [57.883321, 23.331441],
  },
  {
    id: 48,
    name: 'Norra Östersjön',
    latlon: [58.930736, 20.015143],
  },
  {
    id: 49,
    name: 'Mellersta Östersjön',
    latlon: [57.175565, 19.422162],
  },
  {
    id: 51,
    name: 'Sydöstra Östersjön',
    latlon: [55.470136, 18.873106],
  },
  {
    id: 52,
    name: 'Södra Östersjön',
    latlon: [55.232782, 15.315223],
  },
  {
    id: 53,
    name: 'Sydvästra Östersjön',
    latlon: [54.664936, 12.262471],
  },
  {
    id: 55,
    name: 'Öresund',
    latlon: [55.464219, 12.585727],
  },
  {
    id: 54,
    name: 'Bälten',
    latlon: [55.461105, 10.922087],
  },
  {
    id: 58,
    name: 'Vänern',
    latlon: [58.970685, 13.518143],
  },
  {
    id: 56,
    name: 'Kattegatt',
    latlon: [57.108209, 11.381362],
  },
  {
    id: 57,
    name: 'Skagerrak',
    latlon: [58.178234, 9.7891],
  },
];
